const bankIconMapping = {
  65: 'https://logowik.com/content/uploads/images/banco-itau2210.logowik.com.webp',
  76: 'https://logowik.com/content/uploads/images/banco-itau2210.logowik.com.webp',
  108: 'https://logowik.com/content/uploads/images/banco-itau2210.logowik.com.webp',
  109: 'https://logovtor.com/wp-content/uploads/2020/04/sicoob-vector-logo.png',
  113: 'https://logowik.com/content/uploads/images/banco-itau2210.logowik.com.webp',
  114: 'https://logovtor.com/wp-content/uploads/2020/04/sicoob-vector-logo.png',
  115: 'https://logowik.com/content/uploads/images/banco-itau2210.logowik.com.webp',
  116: 'https://logovtor.com/wp-content/uploads/2020/04/sicoob-vector-logo.png',
  117: 'https://logovtor.com/wp-content/uploads/2020/04/sicoob-vector-logo.png',
  118: 'https://logovtor.com/wp-content/uploads/2020/04/sicoob-vector-logo.png',
  119: 'https://logovtor.com/wp-content/uploads/2020/04/sicoob-vector-logo.png',
  120: 'https://logovtor.com/wp-content/uploads/2020/04/sicoob-vector-logo.png',
  121: 'https://seeklogo.com/images/C/Caixa_Economica_Federal-logo-5678C18418-seeklogo.com.png',
  122: 'https://logovtor.com/wp-content/uploads/2020/04/sicoob-vector-logo.png',
  123: 'https://logowik.com/content/uploads/images/banco-itau2210.logowik.com.webp',
  124: 'https://logovtor.com/wp-content/uploads/2020/04/sicoob-vector-logo.png',
  125: 'https://logovtor.com/wp-content/uploads/2020/04/sicoob-vector-logo.png',
  126: 'https://seeklogo.com/images/C/Caixa_Economica_Federal-logo-5678C18418-seeklogo.com.png',
};

export const getBankIcon = (idCarteira) => {
  return bankIconMapping[idCarteira] || 'https://www.svgrepo.com/show/340721/no-image.svg';
};
